import React, { useEffect, useState } from "react";

const icons = [
  { src: "/grain.svg", alt: "wheat" },
  { src: "/hop.svg", alt: "hops" },
  { src: "/berry.svg", alt: "berry" },
  { src: "/vineyard.svg", alt: "vineyard" },
  { src: "/coffee.svg", alt: "coffee" },
];

export default function AnimatedIcons({ mono = true }) {
  const [visibleIcons, setVisibleIcons] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIcon = icons[Math.floor(Math.random() * icons.length)];
      const id = Math.random().toString(36).substring(2, 9);
      const minDistance = 10;

      let tries = 0;
      let x, y;
      let positionOk = false;

      while (tries < 20 && !positionOk) {
        x = Math.random() * 100;
        y = Math.random() * 100;

        positionOk = visibleIcons.every((icon) => {
          const dx = icon.x - x;
          const dy = icon.y - y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          return distance > minDistance;
        });

        tries++;
      }

      if (positionOk) {
        const size = 56 + Math.random() * 16;
        setVisibleIcons((prev) => [
          ...prev,
          { ...randomIcon, id, x, y, size },
        ]);

        setTimeout(() => {
          setVisibleIcons((prev) =>
            prev.filter((icon) => icon.id !== id)
          );
        }, 4000);
      }
    }, 400);

    return () => clearInterval(interval);
  }, [visibleIcons]);

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 0,
      }}
    >
      {visibleIcons.map((icon) =>
        mono ? (
          <div
            key={icon.id}
            style={{
              position: "absolute",
              width: `${icon.size}px`,
              height: `${icon.size}px`,
              left: `${icon.x}%`,
              top: `${icon.y}%`,
              transform: "translate(-50%, -50%)",
              animation: "floatFade 4s ease-in-out forwards",
              backgroundColor: "var(--color-bg-primary)",
              opacity: 0.25,
              WebkitMaskImage: `url(${icon.src})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskSize: "contain",
              WebkitMaskPosition: "center",
              maskImage: `url(${icon.src})`,
              maskRepeat: "no-repeat",
              maskSize: "contain",
              maskPosition: "center",
            }}
          />
        ) : (
          <img
            key={icon.id}
            src={icon.src}
            alt={icon.alt}
            style={{
              position: "absolute",
              width: `${icon.size}px`,
              height: `${icon.size}px`,
              left: `${icon.x}%`,
              top: `${icon.y}%`,
              transform: "translate(-50%, -50%)",
              animation: "floatFade 4s ease-in-out forwards",
              opacity: 0.7,
            }}
          />
        )
      )}
    </div>
  );
}
